module.exports = __webpack_public_path__ + "./static/img/icon-4.d5f929cf698f717e9302c93aa147af8e.png";


//////////////////
// WEBPACK FOOTER
// ./client/src/assets/img/join/icon-4.png
// module id = ./client/src/assets/img/join/icon-4.png
// module chunks = 0